import { CacheHeaders, CacheTypes } from "common";

export const cacheSettings = {
  noCache: {
    [CacheHeaders.TTL]: "0",
    [CacheHeaders.CacheType]: CacheTypes.InMemory,
  },
  shortLived: {
    [CacheHeaders.TTL]: "3", // 3 seconds - average page load duration
    [CacheHeaders.CacheType]: CacheTypes.InMemory,
  },
  mediumLived: {
    [CacheHeaders.TTL]: "", // no medium-lived cache
    [CacheHeaders.CacheType]: "", // no long-lived cache
  },
  longLived: {
    [CacheHeaders.TTL]: "", // no long-lived cache
    [CacheHeaders.CacheType]: "", // no long-lived cache
  },
};
